import { render, staticRenderFns } from "./defHeader.vue?vue&type=template&id=1bb50225&scoped=true"
import script from "./defHeader.vue?vue&type=script&lang=js"
export * from "./defHeader.vue?vue&type=script&lang=js"
import style0 from "./defHeader.vue?vue&type=style&index=0&id=1bb50225&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bb50225",
  null
  
)

export default component.exports